// Single source of truth cho CLI version — đọc runtime từ package.json.
//
// Lý do: trước đây version hardcode ở nhiều file (index.ts, status.ts,
// init-scaffold-variable-builders.ts, print-welcome-screen.ts) → drift bug khi
// bump version chỉ ở 1 chỗ, các chỗ khác in version cũ.
//
// Layout runtime:
//   bin/avatar.js → dist/index.js (bundled) → package.json ở "../package.json"
//   từ dist/. Dev mode (vitest) → src/lib/*.ts → package.json ở "../../package.json".
// Caller dùng helper này không cần biết path, chỉ gọi readCliVersion().

import { readFileSync } from "node:fs";
import { dirname, resolve } from "node:path";
import { fileURLToPath } from "node:url";

// Cache để tránh đọc disk mỗi lần gọi (CLI có thể gọi nhiều lần trong 1 process).
let cachedVersion: string | null = null;

export function readCliVersion(): string {
  if (cachedVersion !== null) return cachedVersion;

  // Tìm package.json bằng cách đi ngược lên từ vị trí file này.
  // Production (bundled): dist/index.js → ../package.json
  // Dev (vitest): src/lib/this-file.ts → ../../package.json
  // Walk up tối đa 5 level để robust với cả 2 layout:
  //   - Bundled (production): dist/index.js → ../package.json (i=1)
  //   - Dev (vitest/tsx): src/lib/*.ts → ../../package.json (i=2)
  // i=0 (cùng dir) cover trường hợp file move ngang sang root tương lai.
  const here = dirname(fileURLToPath(import.meta.url));
  for (let i = 0; i < 5; i++) {
    const candidate = resolve(here, ...Array(i).fill(".."), "package.json");
    try {
      const raw = readFileSync(candidate, "utf8");
      const pkg = JSON.parse(raw) as { name?: string; version?: string };
      // Verify đúng package (tránh nhặt nhầm package.json của repo cha).
      if (pkg.name === "@nalvietnam/avatar-cli" && typeof pkg.version === "string") {
        cachedVersion = pkg.version;
        return cachedVersion;
      }
    } catch {
      // File không tồn tại hoặc JSON invalid → thử level tiếp theo.
    }
  }

  // Fallback: nếu không tìm thấy (case edge — symlink lạ, sandbox), trả "unknown"
  // thay vì throw. Status command vẫn hoạt động, chỉ in "unknown" thay vì version.
  cachedVersion = "unknown";
  return cachedVersion;
}
